import styled from '@emotion/styled'

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 30px;
`

export { ContentContainer }
